import { Box, Card, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import useGetQueryhr from "hooks/useGetQueryhr";
import React from "react";
import { useState } from "react";

const OriginRoomInfo = ({ roomTesterInfo }) => {
  const { data, pageInfo, isLoading, isFetching } = useGetQueryhr(
    "originInfo",
    { testerIdx: roomTesterInfo.testerIdx },
    roomTesterInfo.testerIdx ? true : false
  );

  const realGroupIdx = data?.realGroupIdx || "-";
  const companyName = data?.companyName || "-";
  const groupName = data?.groupName || "-";

  if (isLoading)
    return (
      <Card sx={{ padding: 2, minWidth: 100, display: "flex", justifyContent: "center" }}>
        <CircularProgress size={20} sx={{ color: "#adadad" }} />
      </Card>
    );

  if (!data)
    return (
      <Card sx={{ padding: 2, minWidth: 100, display: "flex", justifyContent: "center" }}>
        <Stack gap={1}>
          <Typography fontSize={11} color={"gray"}>
            병합 전 공고 정보가 없습니다.
          </Typography>
          <Typography fontSize={11} color={"gray"}>
            해당 공고가 병합된 공고인지 확인해 주세요.
          </Typography>
        </Stack>
      </Card>
    );
  return (
    <Card sx={{ padding: 2 }}>
      <Stack rowGap={1}>
        <Grid container gap={0.5}>
          <Typography width={100} color={"gray"}>
            고객사
          </Typography>
          <Typography>{companyName}</Typography>
        </Grid>
        <Grid container gap={0.5}>
          <Typography width={100} color={"gray"}>
            GIDX
          </Typography>
          <Typography>{realGroupIdx}</Typography>
        </Grid>
        <Grid container gap={0.5}>
          <Typography width={100} color={"gray"}>
            공고명
          </Typography>
          <Typography>{groupName}</Typography>
        </Grid>
      </Stack>
    </Card>
  );
};

export default OriginRoomInfo;
